import React from "react";
import styles from "./PageNotificationBanner.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type Props = {
  text: string;
};
const PageNotificationBanner: React.FC<Props> = ({ text }) => {
  return (
    <div className={styles["page-notification-banner"]}>
      <FontAwesomeIcon icon={["fal", "exclamation-circle"]} />
      <p>{text}</p>
    </div>
  );
};

export default PageNotificationBanner;
